import { createQueryKeys } from "@lukemorales/query-key-factory";
import type { QueryKey } from "@tanstack/react-query";

import type { Service } from "../service";

const REVIEW = "review";
const MARK_AS_READ = "markAsRead";
const MARK_ALL_AS_READ = "markAllAsRead";
const GET_MANY = "getMany";
const GET_PAGINATED = "getPaginated";
const GET_INFINITE = "getInfinite";

const MUTATION_KEYS = {
  [MARK_AS_READ]: [REVIEW, MARK_AS_READ],
  [MARK_ALL_AS_READ]: [REVIEW, MARK_ALL_AS_READ],
} as const satisfies Record<string, QueryKey>;

const QUERY_KEYS = createQueryKeys(REVIEW, {
  [GET_MANY]: null,
  [GET_PAGINATED]: (params: Parameters<Service[typeof GET_PAGINATED]>[0]) => [params],
  [GET_INFINITE]: null,
});

export {
  GET_INFINITE,
  GET_MANY,
  GET_PAGINATED,
  MARK_ALL_AS_READ,
  MARK_AS_READ,
  MUTATION_KEYS,
  QUERY_KEYS,
  REVIEW,
};
